export const normalizeSelectionRect = ({ x, y, width, height }) => {
  if (width < 0) {
    return {
      x: x + width,
      y,
      width: Math.abs(width),
      height,
    };
  }
  if (height < 0) {
    return {
      x,
      y: y + height,
      width,
      height: Math.abs(height),
    };
  }
  return { x, y, width, height };
};

export const normalizeSelectionRectFromPoints = (x1, y1, x2, y2) =>
  normalizeSelectionRect({
    x: Math.min(x1, x2),
    y: Math.min(y1, y2),
    width: Math.abs(x2 - x1),
    height: Math.abs(y2 - y1),
  });

export const rectsIntersect = (a, b) =>
  !(
    a.x + a.width < b.x ||
    b.x + b.width < a.x ||
    a.y + a.height < b.y ||
    b.y + b.height < a.y
  );

export const MIN_MARQUEE_SELECTION_SIZE = 4;

export default normalizeSelectionRect;
